import React from 'react';
import { Card, Form } from 'react-bootstrap';
import { motion } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHandHoldingUsd, faPlus, faMinus, faTag } from '@fortawesome/free-solid-svg-icons';

function PriceNegotiation({ proposePrice, setProposePrice, offeredPrice, setOfferedPrice, tarifaResult }) {
  const currentTotal = parseFloat(tarifaResult?.total || 0);

  const handleAdjustPrice = (delta) => {
    const current = parseFloat(offeredPrice || currentTotal);
    const newPrice = Math.max(0.5, current + delta);
    setOfferedPrice(newPrice.toFixed(2));
  };

  return (
    <Card className="border-0 shadow-sm rounded-16 mt-3 overflow-hidden" style={{ background: 'var(--bry-bg-card, #ffffff)', border: '1px solid var(--bry-border-default, #e2e8f0)' }}>
      <Card.Body className="p-3">
        <div
          className="d-flex align-items-center justify-content-between"
          style={{ cursor: 'pointer' }}
          onClick={() => {
            const nextState = !proposePrice;
            setProposePrice(nextState);
            if (nextState && tarifaResult?.total) {
              setOfferedPrice(tarifaResult.total);
            }
          }}
        >
          <div className="d-flex align-items-center gap-2">
            <div style={{
              width: 36, height: 36, borderRadius: '50%',
              backgroundColor: proposePrice ? 'rgba(14, 171, 176, 0.12)' : '#f1f5f9',
              display: 'flex', alignItems: 'center', justifyContent: 'center'
            }}>
              <FontAwesomeIcon icon={faHandHoldingUsd} style={{ color: proposePrice ? 'var(--bry-accent, #0EABB0)' : '#64748b' }} />
            </div>
            <div>
              <span className="fw-bold d-block" style={{ fontSize: 14, color: 'var(--bry-text-primary, #0f172a)' }}>
                Proponer mi propia tarifa
              </span>
              <small style={{ fontSize: 12, color: 'var(--bry-text-secondary, #64748b)' }}>
                {proposePrice ? 'Oferta personalizada activa' : 'Puedes negociar el precio con el conductor'}
              </small>
            </div>
          </div>

          <div className="form-check form-switch m-0 ms-2">
            <input
              className="form-check-input"
              type="checkbox"
              role="switch"
              checked={proposePrice}
              onChange={() => {}} // handled by parent onClick
              style={{ cursor: 'pointer', height: '22px', width: '42px', accentColor: 'var(--bry-accent, #0EABB0)' }}
            />
          </div>
        </div>

        {proposePrice && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            className="mt-3 pt-3 border-top"
          >
            <Form.Label className="small fw-semibold mb-2" style={{ color: 'var(--bry-text-secondary, #64748b)' }}>
              <FontAwesomeIcon icon={faTag} className="me-1 text-primary" style={{ color: 'var(--bry-accent, #0EABB0)' }} />
              ¿Cuánto propones pagar por este servicio?
            </Form.Label>

            <div className="d-flex align-items-center justify-content-center gap-2 my-2">
              <button
                type="button"
                className="btn btn-outline-secondary rounded-circle"
                style={{ width: 40, height: 40, padding: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                onClick={() => handleAdjustPrice(-0.5)}
              >
                <FontAwesomeIcon icon={faMinus} />
              </button>

              <div className="d-flex align-items-center px-3 py-2 rounded-pill" style={{ background: '#f8fafc', border: '1.5px solid var(--bry-accent, #0EABB0)' }}>
                <span className="fw-bold me-1" style={{ fontSize: 20, color: 'var(--bry-accent, #0EABB0)' }}>$</span>
                <Form.Control
                  type="number"
                  step="0.5"
                  min="0.5"
                  value={offeredPrice}
                  onChange={(e) => setOfferedPrice(e.target.value)}
                  className="border-0 bg-transparent fw-bold text-center p-0"
                  style={{ fontSize: 22, width: 90, color: 'var(--bry-text-primary, #0f172a)', outline: 'none', boxShadow: 'none' }}
                />
              </div>

              <button
                type="button"
                className="btn btn-outline-secondary rounded-circle"
                style={{ width: 40, height: 40, padding: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                onClick={() => handleAdjustPrice(0.5)}
              >
                <FontAwesomeIcon icon={faPlus} />
              </button>
            </div>

            {currentTotal > 0 && parseFloat(offeredPrice) < currentTotal && (
              <small className="text-warning d-block text-center mt-2 fw-semibold" style={{ color: '#d97706' }}>
                Tu propuesta es de ${(currentTotal - parseFloat(offeredPrice || 0)).toFixed(2)} por debajo de la tarifa estimada
              </small>
            )}
            {currentTotal > 0 && parseFloat(offeredPrice) >= currentTotal && (
              <small className="text-success d-block text-center mt-2 fw-semibold" style={{ color: '#16a34a' }}>
                Oferta igual o mayor a la tarifa estimada ✓
              </small>
            )}

            <small className="text-muted d-block text-center mt-1" style={{ fontSize: 11 }}>
              Los conductores cercanos verán tu oferta y decidirán si la aceptan.
            </small>
          </motion.div>
        )}
      </Card.Body>
    </Card>
  );
}

export default PriceNegotiation;
